import { randomNumber } from '../../../../utilities'
import { BloodProductAdministrationConstants } from './bloodProductAdministration.constants'
import { IBloodProductAdministrationAction, IBloodProductAdministrationState } from './bloodProductAdministration.types'

export const initialBloodProductAdministrationState: IBloodProductAdministrationState = {
  ptIdVerified: null,
  witness1: '',
  witness2: '',
  clinicalIndicator: null,
  crossMatched: null,
  transfusionConsent: null,
  transfusionConsentDate: '',
  transfusionConsentTime: '',
  transfusionConsentDateTime: '',
  bloodProduct: null,
  productId: '',
  bloodProductType: null,
  unitExpDate: '',
  unitExpTime: '',
  unitExpDateTime: '',
  siteAdministered: '',
  transfusionStartDate: '',
  transfusionStartTime: '',
  transfusionStartDateTime: '',
  transfusionEndDate: '',
  transfusionEndTime: '',
  transfusionEndDateTime: '',
  volumeInfused: '',
  volumeInfusedUnit: null,
  route: null,
  unitCompleted: false,
  warmerUsed: false,
  transfusionOrder: null,
  impliedEmergentConsentReason: null,
  assessedBy: null,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  type: 'Blood Administration',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  isEkgImport: null,
  nemsisCode: null,
}

export function bloodProductAdministrationReducer(
  state: IBloodProductAdministrationState = initialBloodProductAdministrationState,
  action: IBloodProductAdministrationAction
): IBloodProductAdministrationState {
  switch (action.type) {
    case BloodProductAdministrationConstants.SET_PT_ID_VERIFIED:
      return { ...state, ptIdVerified: action.ptIdVerified }
    case BloodProductAdministrationConstants.SET_WITNESS1:
      return { ...state, witness1: action.witness1 }
    case BloodProductAdministrationConstants.SET_WITNESS2:
      return { ...state, witness2: action.witness2 }
    case BloodProductAdministrationConstants.SET_CLINICAL_INDICATORS:
      return { ...state, clinicalIndicator: action.clinicalIndicator }
    case BloodProductAdministrationConstants.SET_CROSS_MATCHED:
      return { ...state, crossMatched: action.crossMatched }
    case BloodProductAdministrationConstants.SET_TRANSFUSION_CONSENT:
      return { ...state, transfusionConsent: action.transfusionConsent }
    case BloodProductAdministrationConstants.SET_TRANSFUSION_CONSENT_DATE:
      return { ...state, transfusionConsentDate: action.date }
    case BloodProductAdministrationConstants.SET_TRANSFUSION_CONSENT_TIME:
      return { ...state, transfusionConsentTime: action.time }
    case BloodProductAdministrationConstants.SET_TRANSFUSION_CONSENT_DATE_TIME:
      return {
        ...state,
        transfusionConsentTime: action.time,
        transfusionConsentDate: action.date,
      }
    case BloodProductAdministrationConstants.SET_BLOOD_PRODUCT:
      return {
        ...state,
        bloodProduct: action.bloodProduct,
      }
    case BloodProductAdministrationConstants.SET_PRODUCT_ID:
      return { ...state, productId: action.productId }
    case BloodProductAdministrationConstants.SET_BLOOD_PRODUCT_TYPE:
      return { ...state, bloodProductType: action.bloodProductType }
    case BloodProductAdministrationConstants.SET_UNIT_EXPIRY_DATE:
      return { ...state, unitExpDate: action.date }
    case BloodProductAdministrationConstants.SET_UNIT_EXPIRY_TIME:
      return { ...state, unitExpTime: action.time }
    case BloodProductAdministrationConstants.SET_UNIT_EXPIRY_DATE_TIME:
      return { ...state, unitExpTime: action.time, unitExpDate: action.date }
    case BloodProductAdministrationConstants.SET_SITE_ADMINISTERED:
      return { ...state, siteAdministered: action.siteAdministered }
    case BloodProductAdministrationConstants.SET_TRANSFUSION_START_DATE:
      return { ...state, transfusionStartDate: action.date }
    case BloodProductAdministrationConstants.SET_TRANSFUSION_START_TIME:
      return { ...state, transfusionStartTime: action.time }
    case BloodProductAdministrationConstants.SET_TRANSFUSION_START_DATE_TIME:
      return {
        ...state,
        transfusionStartTime: action.time,
        transfusionStartDate: action.date,
      }
    case BloodProductAdministrationConstants.SET_TRANSFUSION_END_DATE:
      return { ...state, transfusionEndDate: action.date }
    case BloodProductAdministrationConstants.SET_TRANSFUSION_END_TIME:
      return { ...state, transfusionEndTime: action.time }
    case BloodProductAdministrationConstants.SET_TRANSFUSION_END_DATE_TIME:
      return {
        ...state,
        transfusionEndTime: action.time,
        transfusionEndDate: action.date,
      }
    case BloodProductAdministrationConstants.SET_VOLUME_INFUSED:
      return { ...state, volumeInfused: action.volumeInfused }
    case BloodProductAdministrationConstants.SET_VOLUME_INFUSED_UNIT:
      return { ...state, volumeInfusedUnit: action.volumeInfusedUnit }
    case BloodProductAdministrationConstants.SET_ROUTE:
      return { ...state, route: action.route }
    case BloodProductAdministrationConstants.SET_UNIT_COMPLETED:
      return { ...state, unitCompleted: action.unitCompleted }
    case BloodProductAdministrationConstants.SET_WARMER_USED:
      return { ...state, warmerUsed: action.warmerUsed }
    case BloodProductAdministrationConstants.SET_TRANSFUSION_ORDER:
      return { ...state, transfusionOrder: action.transfusionOrder }
    case BloodProductAdministrationConstants.SET_IMPLIED_EMERGENT_CONSENT_REASON:
      return { ...state, impliedEmergentConsentReason: action.impliedEmergentConsentReason }
    case BloodProductAdministrationConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case BloodProductAdministrationConstants.SET_DATE:
      return { ...state, date: action.date }
    case BloodProductAdministrationConstants.SET_TIME:
      return { ...state, time: action.time }
    case BloodProductAdministrationConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case BloodProductAdministrationConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case BloodProductAdministrationConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case BloodProductAdministrationConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case BloodProductAdministrationConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case BloodProductAdministrationConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case BloodProductAdministrationConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case BloodProductAdministrationConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case BloodProductAdministrationConstants.SET_STATE:
      return { ...action.bloodProductAdministrationState, updateInputRows: true }
    case BloodProductAdministrationConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case BloodProductAdministrationConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case BloodProductAdministrationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case BloodProductAdministrationConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case BloodProductAdministrationConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case BloodProductAdministrationConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case BloodProductAdministrationConstants.RESET_STATE:
      return {
        ...initialBloodProductAdministrationState,
        key: randomNumber().toString(),
        updateInputRows: true,
      }
    default:
      return state
  }
}
